import {
  StyledGraphHeader,
  StyledGraphViewOptions
} from '../../ResourceAllocationOverview.style';
import GranularityToggler from './GranularityToggler';
import GraphStackingToggler from './GraphStackingToggler';
import GraphViewDropDown from './GraphViewsDropDown';
import ResourceTypeDropDown from './ResourceTypeDropDown';

const Header = ({
  granularity,
  setGranularity,
  resourceType,
  setResourceType,
  graphView
}) => {
  return (
    <StyledGraphHeader>
      Allocation Over Time By
      <ResourceTypeDropDown
        resourceType={resourceType}
        onChange={resourceType => setResourceType(resourceType)}
      />
      <GranularityToggler
        granularity={granularity}
        onChange={granularity => setGranularity(granularity)}
      />
      <StyledGraphViewOptions>
        <GraphStackingToggler graphView={graphView} />
        <GraphViewDropDown graphView={graphView} />
      </StyledGraphViewOptions>
    </StyledGraphHeader>
  );
};

export default Header;
